import { SidebarGroup, CourseDef } from '../../types';
import { boasVindas } from './courses/boasVindas/_index';
import { salaDeSinaisAoVivo } from './courses/salaDeSinaisAoVivo/_index';
import { comecandoNasOpcoesBinarias } from './courses/comecandoNasOpcoesBinarias/_index';
import { aMelhorCorretora } from './courses/aMelhorCorretora/_index';
import { principiosDoTrader } from './courses/principiosDoTrader/_index';
import { mindsetDoTrader } from './courses/mindsetDoTrader/_index';
import { gestaoFinanceira } from './courses/gestaoFinanceira/_index';

export const module1Name = '1️⃣ - COMECE POR AQUI';

export const module1Courses: CourseDef[] = [
  boasVindas,
  salaDeSinaisAoVivo,
  comecandoNasOpcoesBinarias,
  aMelhorCorretora,
  principiosDoTrader,
  mindsetDoTrader,
  gestaoFinanceira,
];

export const module1CoursesSidebar: SidebarGroup[] = module1Courses.map(c => ({
  title: c.courseTitle,
  countLabel: `${c.lessons.length} aulas`,
  items: c.lessons.map(l => ({ label: l.title, href: `/area/produto/item/${l.itemId}` })),
}));

